import { onCleanup } from 'solid-js'

export interface SSEOptions {
  url: string
  token: string
  onMessage: () => void
}

export function createSSE(options: SSEOptions): void {
  const urlWithToken = `${options.url}?token=${encodeURIComponent(options.token)}`
  const es = new EventSource(urlWithToken)
  es.onmessage = () => options.onMessage()
  onCleanup(() => es.close())
}
